"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkSampleType = exports.StatisticalAggregatorType = exports.SmootherType = void 0;
var SmootherType;
(function (SmootherType) {
    SmootherType["LAST_SAMPLE"] = "LAST_SAMPLE";
    SmootherType["MEAN"] = "MEAN";
    SmootherType["HARMONIC_MEAN"] = "HARMONIC_MEAN";
    SmootherType["KAMA"] = "KAMA";
    SmootherType["SHAKA_BASE_EWMA"] = "SHAKA_BASE_EWMA";
    SmootherType["SHAKA_COMPOSITE_EWMA"] = "SHAKA_COMPOSITE_EWMA";
    SmootherType["COMPOSITE"] = "COMPOSITE";
})(SmootherType || (exports.SmootherType = SmootherType = {}));
var StatisticalAggregatorType;
(function (StatisticalAggregatorType) {
    StatisticalAggregatorType["STANDARD_DEVIATION"] = "STANDARD_DEVIATION";
})(StatisticalAggregatorType || (exports.StatisticalAggregatorType = StatisticalAggregatorType = {}));
var NetworkSampleType;
(function (NetworkSampleType) {
    NetworkSampleType["Audio"] = "Audio";
    NetworkSampleType["Video"] = "Video";
})(NetworkSampleType || (exports.NetworkSampleType = NetworkSampleType = {}));
